import { TableCell, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { HomePrintSection, visibleOnlyWhenPrinting } from "../homePrintMode"
import { PrintTable } from "../PrintTable"
import type { GuestListDisplayRow } from "./guestsOverviewLib"

const useStyles = makeStyles()(() => ({
    root: visibleOnlyWhenPrinting(HomePrintSection.GUEST_LIST),
}))

type Props = Readonly<{
    rows: ReadonlyArray<GuestListDisplayRow>
    date: string
}>

export function PrintGuestList({ rows, date }: Props) {
    const { classes } = useStyles()

    return (
        <PrintTable
            className={classes.root}
            title={
                <LocalizedStrict id="service-center-reports-dashboard-guests-overview-print-title" vars={{ date }}>
                    <Typography variant="h6">Guests in house · {date}</Typography>
                </LocalizedStrict>
            }
            headerCells={
                <>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-name-header">
                        <TableCell>Name</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-company-header">
                        <TableCell>Company</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-meeting-header">
                        <TableCell>Meeting</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-host-header">
                        <TableCell>Host</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-room-header">
                        <TableCell>Room</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-guests-overview-csv-time-header">
                        <TableCell>Time</TableCell>
                    </LocalizedStrict>
                </>
            }
            rows={rows.map((row) => ({
                key: row.key,
                cells: [row.name, row.company, row.meeting, row.host, row.room, row.time],
            }))}
            empty={
                <LocalizedStrict id="service-center-reports-dashboard-guests-overview-print-empty">
                    <Typography variant="body1">No guests in house</Typography>
                </LocalizedStrict>
            }
        />
    )
}
